import * as apiClient from "./axiosApiClient";
import { joinUrlWithRoute } from "../utils/urlUtils";

const baseUrl = apiClient.REACT_APP_API_TARGET_ACCOUNT_BASE_URL;
const contactsBaseUrl = apiClient.REACT_APP_CONTACTS_API_BASE_URL;

export function postRateCompany(request) {
    const url = joinUrlWithRoute(baseUrl, "/rate");
    return apiClient.post(url, request);
}

export function updateTargetAccount(request) {
    const url = joinUrlWithRoute(baseUrl, "/");
    return apiClient.post(url, request);
}

export function deleteCompany(linkedinCompanyId) {
    const url = joinUrlWithRoute(baseUrl, `/linkedinCompanyId/${linkedinCompanyId}`);
    return apiClient.httpDelete(url);
}

export function addTargetAccount(request) {
    const url = joinUrlWithRoute(baseUrl, "/add");
    return apiClient.post(url, request);
}

export function uploadFile(request, config = {}) {
    const url = joinUrlWithRoute(baseUrl, "/upload");
    return apiClient.httpUpload(url, request, config);
}

export function uploadFileAsync(request, config = {}) {
    const url = joinUrlWithRoute(baseUrl, "/upload-async");
    return apiClient.httpUpload(url, request, config);
}

export function getUploadFileStatus(jobId) {
    const url = joinUrlWithRoute(baseUrl, `/upload-status/${jobId}`);
    return apiClient.get(url);
}

export function assignResponsible(request) {
    const url = joinUrlWithRoute(baseUrl, "/assign-responsible");
    return apiClient.put(url, request);
}

export function bulkSendToTargetAccounts(request) {
    const url = joinUrlWithRoute(baseUrl, "/bulk/send-to-target");
    return apiClient.post(url, request);
}

export function bulkSendToExclusion(request) {
    const url = joinUrlWithRoute(baseUrl, "/bulk/send-to-exclusion");
    return apiClient.post(url, request);
}

export function bulkSendToExclusionAsync(request) {
    const url = joinUrlWithRoute(baseUrl, "/bulk/send-to-exclusion-async");
    return apiClient.post(url, request);
}

export function getBulkSendToExclusionStatus(jobId, since = 0) {
    const url = joinUrlWithRoute(baseUrl, `/bulk/send-to-exclusion-status/${jobId}`);
    return apiClient.getWithParams(url, { since });
}

export function bulkChangeTargetAccountList(request) {
    const url = joinUrlWithRoute(baseUrl, "/bulk/change-list");
    return apiClient.post(url, request);
}

export function bulkChangeTargetAccountListAsync(request) {
    const url = joinUrlWithRoute(baseUrl, "/bulk/change-list-async");
    return apiClient.post(url, request);
}

export function getBulkChangeTargetAccountListStatus(jobId, since = 0) {
    const url = joinUrlWithRoute(baseUrl, `/bulk/change-list-status/${jobId}`);
    return apiClient.getWithParams(url, { since });
}

export function bulkRemoveTargetAccounts(request) {
    const url = joinUrlWithRoute(baseUrl, "/bulk/remove");
    return apiClient.post(url, request);
}

export function bulkRemoveTargetAccountsAsync(request) {
    const url = joinUrlWithRoute(baseUrl, "/bulk/remove-async");
    return apiClient.post(url, request);
}

export function getBulkRemoveTargetAccountsStatus(jobId, since = 0) {
    const url = joinUrlWithRoute(baseUrl, `/bulk/remove-status/${jobId}`);
    return apiClient.getWithParams(url, { since });
}

export function getContacts(params = {}, { signal } = {}) {
    const url = joinUrlWithRoute(contactsBaseUrl, `/`);
    const opts = signal ? { signal } : {};
    if (params && Object.keys(params).length > 0) {
        return apiClient.getWithParams(url, params, opts);
    }
    return apiClient.get(url, opts);
}

export function addContacts(request) {
    const url = joinUrlWithRoute(contactsBaseUrl, `/`);
    return apiClient.post(url, request);
}

export function updateContacts(contactId, request) {
    const url = joinUrlWithRoute(contactsBaseUrl, `/${contactId}`);
    return apiClient.put(url, request);
}

export function deleteContact(contactId) {
    const url = joinUrlWithRoute(contactsBaseUrl, `/${contactId}`);
    return apiClient.httpDelete(url);
}

export function bulkDeleteContacts(contactIds = []) {
    const url = joinUrlWithRoute(contactsBaseUrl, `/bulk-delete`);
    return apiClient.post(url, { contactIds });
}

export function bulkUpdateContactsCompany(request) {
    const url = joinUrlWithRoute(contactsBaseUrl, `/bulk-update-company`);
    return apiClient.post(url, request);
}

export function bulkDeleteContactsAsync(contactIds = []) {
    const url = joinUrlWithRoute(contactsBaseUrl, `/bulk-delete-async`);
    return apiClient.post(url, { contactIds });
}

export function getBulkDeleteContactsStatus(jobId, since = 0) {
    const url = joinUrlWithRoute(contactsBaseUrl, `/bulk-delete-status/${jobId}`);
    return apiClient.getWithParams(url, { since });
}

export function bulkSendToTargetAccountsAsync(request) {
    const url = joinUrlWithRoute(baseUrl, "/bulk/send-to-target-async");
    return apiClient.post(url, request);
}

export function getBulkSendToTargetAccountsStatus(jobId, since = 0) {
    const url = joinUrlWithRoute(baseUrl, `/bulk/send-to-target-status/${jobId}`);
    return apiClient.getWithParams(url, { since });
}

export function uploadContactsFile(request, config = {}) {
    const url = joinUrlWithRoute(contactsBaseUrl, "/upload");
    return apiClient.httpUpload(url, request, config);
}

export function uploadContactsFileAsync(request, config = {}) {
    const url = joinUrlWithRoute(contactsBaseUrl, "/upload-async");
    return apiClient.httpUpload(url, request, config);
}

export function getUploadContactsFileStatus(jobId) {
    const url = joinUrlWithRoute(contactsBaseUrl, `/upload-status/${jobId}`);
    return apiClient.get(url);
}

export function getCompanies(params = {}) {
    const url = joinUrlWithRoute(contactsBaseUrl, `/companies`);
    return apiClient.getWithParams(url, params);
}
